import { z } from 'zod';

import { nonEmptyString } from './data';

export const visitOutcomeSchema = z.enum(
  [
    'failed:inconvenient',
    'failed:named-tenant-not-home',
    'failed:nobody-home',
    'failed:refusal-to-answer-door',
    'failed:refusal-to-cooperate',
    'failed:other-reason',
    'success:data-validated',
  ],
  { message: 'Please select an outcome' },
);

/** Source of truth for the `visits` user store table (see userStoreSchema.ts) */
export const visitSchema = z.object({
  propertyId: z.number(),
  visitId: nonEmptyString,
  officerId: nonEmptyString,
  officerCamdenAccountName: nonEmptyString,
  officerName: nonEmptyString,
  timestamp: z.iso.datetime({ offset: true }),
  outcome: visitOutcomeSchema,
  notes: z.string().optional(),
});

export const visitUpdateSchema = visitSchema.partial().extend({
  visitId: visitSchema.shape.visitId,
});
